module.exports = __webpack_public_path__ + "img/banner-icon.4cbf7802.png";